import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon/geocode-icon.svg'


const _hoisted_1 = { class: "form-terminal" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-6" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "label-text required" }, "Nama Halte/Terminal", -1)
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "label-text required" }, "Kode", -1)
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "label-text required" }, "Jenis", -1)
const _hoisted_12 = { class: "flex flex-wrap gap-3" }
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "label-text" }, "Keterangan", -1)
const _hoisted_16 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_17 = { class: "flex gap-2 items-start" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "15",
  class: "mt-1"
}, null, -1)
const _hoisted_19 = { class: "color-blue-1" }
const _hoisted_20 = { class: "flex mt-auto gap-2" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Simpan")
const _hoisted_23 = { class: "invalid-feedback" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Field = _resolveComponent("Field")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_MapsSearch = _resolveComponent("MapsSearch")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schemaValidation,
      "initial-values": _ctx.formValues
    }, {
      default: _withCtx(({ errors, values, setFieldValue }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", null, _toDisplayString(`${_ctx.modalTitle} Halte/Terminal`), 1),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_Field, { name: "Name" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                    placeholder: "Tulis Nama Halte/Terminal",
                    maxlength: 50
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_6, _toDisplayString(errors.Name), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Field, { name: "Code" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    class: `input-primary ${errors.Code ? 'input-invalid' : ''}`,
                    placeholder: "Tulis Kode Halte/Terminal",
                    maxlength: 3
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_9, _toDisplayString(errors.Code), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Field, { name: "Type" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionType, (opTypes, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex align-items-center",
                        key: idx
                      }, [
                        _createVNode(_component_RadioButton, {
                          inputId: `types${idx}`,
                          modelValue: values.Type,
                          "onUpdate:modelValue": ($event: any) => ((values.Type) = $event),
                          name: "Type",
                          value: opTypes.value,
                          onChange: () => setFieldValue('Type', opTypes.value)
                        }, null, 8, ["inputId", "modelValue", "onUpdate:modelValue", "value", "onChange"]),
                        _createElementVNode("label", {
                          for: `types${idx}`,
                          class: "ml-2"
                        }, _toDisplayString(opTypes.label), 9, _hoisted_13)
                      ]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _withDirectives(_createElementVNode("div", { class: "invalid-feedback" }, _toDisplayString(errors.Type), 513), [
                [_vShow, errors.Type]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_Field, {
                name: "Description",
                as: "textarea",
                placeholder: "Tulis Keterangan",
                class: "input-primary"
              })
            ]),
            (_ctx.address)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.address), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_Button, {
                class: "btn-back",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onBack()))
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                type: "submit",
                class: "btn-primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_Field, { name: "Latlng" }, {
              default: _withCtx(() => [
                _createVNode(_component_MapsSearch, {
                  onSendDataLocation: (e) => {
              setFieldValue('Latlng', { lat: e.latLng.lat().toString(), lng: e.latLng.lng().toString() })
              _ctx.getLocationFromMaps(e)
            },
                  existLat: values.Latlng?.lat,
                  existLng: values.Latlng?.lng
                }, null, 8, ["onSendDataLocation", "existLat", "existLng"])
              ]),
              _: 2
            }, 1024),
            _createElementVNode("div", _hoisted_23, _toDisplayString(errors.Latlng), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema", "initial-values"])
  ]))
}